
























import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class SocialShare extends Vue {
  @Prop() isShareVisible: boolean;
  currentUrl: string = '';

  created() {
    this.currentUrl = window.location.href;
  }
}
